import {
  EProductsDetailMode,
  ETabsActiveKeyType,
  EProductsType,
  EProductsDetailModeName,
  EProductStatus,
} from '@/views/productCenter/commodity/types'
import type { IGetProductDetailRouteParams } from '@/views/productCenter/types'
import { productsNameDictionary } from './commodity/constants'
import { aCommodity, aUser } from '@/apis'
import * as func from '@/func'
import { message } from 'ant-design-vue'
import { MapAuditStatus } from '@/enum/commodity'

export const useGoProductDetail = (
  { commodityType, isReplace, isNewTab }: { commodityType?: EProductsType; isReplace?: boolean; isNewTab?: boolean } = { isReplace: false }
) => {
  const router = useRouter()
  const goDetail = async ({
    mode,
    isMainImage,
    addDetailSource,
    commodityId,
    commodityType: commodityTypeInner,
    random,
    skuId,
    auditStatus,
  }: IGetProductDetailRouteParams) => {
    const tabsActive = skuId
      ? mode === EProductsDetailMode['CHECK']
        ? ETabsActiveKeyType['SKU_LIST']
        : ETabsActiveKeyType['SPU_LIST']
      : ETabsActiveKeyType['SPU_LIST']
    // 20250421隐藏有图编辑
    // const modeName = mode === EProductsDetailMode['EDIT'] && isMainImage === 1 ? EProductsDetailMode['IMAGE_EDITING'] : mode
    const modeName = mode
    let query: TCommon.Json = {
      tabsActive: tabsActive,
      mode: modeName,
      addDetailSource,
      commodityId,
      commodityType: commodityTypeInner ?? commodityType,
      random,
      skuId,
      t: EProductsDetailModeName[modeName] + productsNameDictionary[commodityTypeInner ?? commodityType!],
    }

    if (mode !== EProductsDetailMode['ADD'] && mode !== EProductsDetailMode['CHECK']) {
      // const isReview = await aCommodity.auditDataForm.querySkuIsItUnderReview({ spuId: commodityId })
      const isReview = skuId
        ? auditStatus === MapAuditStatus['审核中']
        : await aCommodity.auditDataForm.querySkuIsItUnderReview({ spuId: commodityId })
      if (isReview) return message.warn('正在审核中，不可操作')
    }

    const path = '/productCenter/commodity/productDetail'
    if (!isNewTab) {
      const routerFn = isReplace ? router.replace : router.push
      routerFn({ path, query })
    } else {
      const queryExclude = Object.fromEntries(Object.entries(query).filter(([_, value]) => value !== undefined && value !== null))
      const params = new URLSearchParams(queryExclude).toString()
      const url = window.location.origin
      window.open(`${url}${path}?${params}`)
    }
  }
  return goDetail
}

export const useSkuTags = (type: ETabsActiveKeyType, fn?: Function) => {
  const selectedTags = ref<string[]>([])
  const currentRowId = ref('')
  const harvestAddressModalVisible = ref(false)
  const tagOptionData = ref<
    {
      title: string
      key: string
    }[]
  >([])

  //获取tags
  const getTotalTags = () => {
    aUser.tag
      .listTags({
        bizType: 1, //0-会员；1-商品；2-用户
        state: 0, //（0-启用;1-停用）
      })
      .then((res) => {
        const tagOptionList = res.map((item) => ({
          title: item.name!,
          key: item.id!,
        }))
        tagOptionData.value = tagOptionList
      })
  }

  // getTotalTags()

  // 打开弹窗
  const handleTag = (id: string) => {
    harvestAddressModalVisible.value = true
    currentRowId.value = id
    selectedTags.value = []
    if (!tagOptionData.value.length) getTotalTags()
    // 设置当前已选的标签
    if (type == ETabsActiveKeyType['SKU_LIST']) {
      // 设置当前已选的标签，sku需回显标签，spu打标签会显示在对应sku上，即spu无需回显
      aCommodity.sku.querySkuTags({ id }).then((res) => {
        selectedTags.value = res.map((i) => i.tagId)
      })
    }
  }

  //保存tags
  const submitTag = () => {
    const api = type == ETabsActiveKeyType['SKU_LIST'] ? aCommodity.sku.skuPlayTag : aCommodity.spu.spuPlayTag
    api({ id: currentRowId.value, tagIdList: selectedTags.value }).then(() => {
      message.success('操作成功')
      fn && fn()
    })
  }

  // 激活/作废
  const changeStatus = async (id: string, status: EProductStatus, commodityId: string) => {
    const isReview = await aCommodity.auditDataForm.querySkuIsItUnderReview({ spuId: commodityId })
    if (isReview) return message.warn('正在审核中，不可操作')
    const statusName = status === EProductStatus['TO_VOID'] ? '作废' : '激活'
    const content =
      status === EProductStatus['TO_VOID']
        ? '商品作废操作将导致此商品在任何渠道上无法进行销售，已经上架的三方电商平台将做强制商品下架处理；已经产生的销售单、采购单 、收货单、发货单、电商订单不受影响，是否确定作废？'
        : '是否激活?'
    await func.confirm(content, { okText: statusName, title: '提示' })
    const apiService = type == ETabsActiveKeyType['SKU_LIST'] ? aCommodity.sku : aCommodity.spu
    const api = status === EProductStatus['TO_VOID'] ? apiService.invalid : apiService.activation
    api({ id }).then(() => {
      message.success('操作成功')
      fn && fn()
    })
  }
  return { selectedTags, harvestAddressModalVisible, tagOptionData, submitTag, changeStatus, handleTag }
}

// 类目
export const useCategory = async (id: string, commodityType?: number | string) => {
  return await aCommodity.category.categoryList({ id, commodityType: commodityType?.toString() })
}

// 判断是否待定类目
export const useIsUndetermined = (code?: string) => {
  return code ? ['ZZZZ9', 'ZZZZ9Z9', 'ZZZ', 'ZZ', 'Z'].includes(code) : false
}
